import { ThumbDownRounded, ThumbUpRounded } from '@mui/icons-material';
import { Box, Theme, Typography } from '@mui/material';

interface FeedbackRatingsProps {
  rating: number;
  ratingScale: number;
  onRatingChange?: (rating: number) => void;
}

export const FeedbackRatings = ({
  rating,
  ratingScale,
  onRatingChange,
}: FeedbackRatingsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: { xs: 1, sm: 1.5 },
      }}>
      <ThumbDownRounded
        sx={[
          styles.thumbsDownUp,
          rating > 0 &&
            rating < Math.round(ratingScale / 2) &&
            styles.thumbsDownUpSelected,
        ]}
      />
      <Box sx={styles.ratings}>
        {[...Array(ratingScale).keys()].map((_, index) => (
          <Box
            key={index + 1}
            sx={[styles.rating, rating === index + 1 && styles.ratingSelected]}
            onClick={() => onRatingChange?.(index + 1)}>
            <Typography variant="body2SemiBold">{index + 1}</Typography>
          </Box>
        ))}
      </Box>
      <ThumbUpRounded
        sx={[
          styles.thumbsDownUp,
          rating > 0 &&
            rating >= Math.round(ratingScale / 2) &&
            styles.thumbsDownUpSelected,
        ]}
      />
    </Box>
  );
};

const styles = {
  thumbsDownUp: (theme: Theme) => ({
    color: 'grey150',
    width: 40,
    height: 40,
    [theme.breakpoints.down('sm')]: {
      width: 24,
      height: 24,
    },
  }),
  thumbsDownUpSelected: {
    color: 'secondary.main',
  },
  ratings: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: { xs: 1, sm: 1.5 },
  },
  rating: {
    cursor: 'pointer',
    width: { xs: 32, sm: 48 },
    height: { xs: 32, sm: 48 },
    borderRadius: '50%',
    border: 1,
    borderColor: 'text.trace',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ratingSelected: {
    backgroundColor: 'secondary.main',
    border: 'none',
    color: 'white',
  },
};
